import { QuestionType, type CampaignQuestion } from '@/components/campaigns/CampaignQuestionsEditor/types';
import { TextAnswer, FormulaAnswer, BooleanAnswer, NumericAnswer, MultiselectAnswer, NoAnswer } from './QuestionAnswerTypes';

export type QuestionAnswerProps =
    | { type: QuestionType.TEXT; answer: string | null }
    | {
          type: QuestionType.FORMULA;
          answer: string | null;
          formula?: string;
          prefilledFormula?: string | null;
          allQuestions?: CampaignQuestion[];
      }
    | { type: QuestionType.BOOLEAN; answer: boolean | string | null }
    | { type: QuestionType.NUMERIC; answer: number | string | null; maxScore: number }
    | { type: QuestionType.MULTISELECT; answer: string[] | null };

const QuestionAnswer: React.FC<QuestionAnswerProps> = (props) => {
    if (props.answer === null) {
        return <NoAnswer text="N/A" />;
    }

    switch (props.type) {
        case QuestionType.TEXT:
            return <TextAnswer answer={props.answer} />;
        case QuestionType.FORMULA:
            return (
                <FormulaAnswer
                    answer={props.answer}
                    formula={props.formula}
                    prefilledFormula={props.prefilledFormula}
                    allQuestions={props.allQuestions}
                />
            );
        case QuestionType.BOOLEAN:
            return <BooleanAnswer answer={props.answer} />;
        case QuestionType.NUMERIC:
            return <NumericAnswer answer={props.answer} maxScore={props.maxScore} />;
        case QuestionType.MULTISELECT:
            return props.answer.length === 0 ? <NoAnswer /> : <MultiselectAnswer answer={props.answer} />;
    }
};

export default QuestionAnswer;
